module.exports = __webpack_public_path__ + "img/mushiLogo.5addaef7.svg";